import {PropsWithChildren} from 'react';
import {
  Box,
  Flex,
  Button,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
  MenuDivider,
  useColorModeValue,
  WrapItem,
  Text,
  HStack,
  VStack,
  Avatar
} from '@chakra-ui/react';

import {
  FiChevronDown,
  FiSettings,
  FiPhone,
  FiVideo,
  FiPlay
} from 'react-icons/fi';

export const UserMenu: React.FC<PropsWithChildren> = ({}) => {
  return (
    <Flex p='24px 32px' alignItems={'center'}>
      <Menu>
        <MenuButton transition='all 0.3s' _focus={{boxShadow: 'none'}}>
          <HStack>
            <Avatar size={'sm'} />
            <VStack
              display={{base: 'none', md: 'flex'}}
              alignItems='flex-start'
              spacing='1px'
              ml='2'
            >
              <Text fontSize='sm'>Max Mustermann</Text>
              <Text fontSize='xs'>Lehrer</Text>
            </VStack>
            <Box display={{base: 'none', md: 'flex'}}>
              <FiChevronDown />
            </Box>
          </HStack>
        </MenuButton>
        <MenuList
          bg={useColorModeValue('white', 'gray.900')}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
        >
          <WrapItem as='span' p={3}>
            <Text fontSize='sm'>Max Mustermann</Text>
          </WrapItem>
          <MenuDivider />

          <MenuItem>Feedback</MenuItem>
          <MenuItem>AGB</MenuItem>
          <MenuItem>Impressum</MenuItem>
          <MenuDivider />

          <MenuItem icon={<FiVideo size={18} />}>Anleitungen</MenuItem>
          <MenuItem icon={<FiPhone size={18} />}>+49 30 300 244 003</MenuItem>
          <MenuDivider />
          <MenuItem icon={<FiSettings size={18} />}>Einstellungen</MenuItem>
          <WrapItem as='span' p={2}>
            <Button
              aria-label='Abmelden Button'
              size='sm'
              colorScheme='blue'
              flex={1}
            >
              Abmelden
            </Button>
          </WrapItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};
